<div class="business-list-view col-md-12 padding-right-0 padding-left-0"> 
  <div class="hpanel"> 

    <div class="comNavBar panel-body border-radius-top-left-right-6">
      <div class="navIteam">
        <h6 class="fw-bold" data-toggle="tooltip" data-placement="top" title="{{ values.communityName }}">
          {{ values.communityName | truncate: 15 }}
        </h6>
        <div class="red">
          <p *ngIf="adminTotal === 0 || adminTotal === 1">
            {{ adminTotal }} Admin
          </p>
          <p *ngIf="adminTotal > 1">
            {{ adminTotal }} Admins
          </p>
        </div> 
      </div>
      <div class="navIteam pos-rel-10">
        <input #adminSearch type="text" class="form-control pd-lt-10 search-field-pad" placeholder="Search Admin "
          aria-label="Amount (to the nearest dollar)" name="searchadmin" id="searchadmin" (keyup)="onSearchCommunity(adminSearch.value)"/>
        <ng-icon name="tablerSearch" class="pos-rel-25"></ng-icon>
      </div>
      <div class="navIteam">
        <div class="btn-group unified-btn" dropdown container="body" placement="bottom right">
          <button type="button" class="btn primary-btn filter-single-btn" dropdownToggle data-toggle="dropdown">
            <span>{{ selectedFilter|titlecase }}</span>
            <ng-icon name="tablerFilter"></ng-icon>
          </button>
          <ul class="dropdown-menu no-padding dropdown-menu-right leftview" *dropdownMenu role="menu">
            <li role="menuitem">
              <a class="dropdown-item" [class.selected]="selectedFilter === 'All'" (click)="setFilter('All'); adminSearch.value = ''">All<span class="sr-only">(current)</span></a>
            </li>
            <li role="menuitem">
              <a class="dropdown-item" [class.selected]="selectedFilter === 'ADMIN'" (click)="setFilter('ADMIN'); adminSearch.value = ''">Admin</a>
            </li>
            <li role="menuitem" *ngIf="values?.isSuperAdmin">
              <a class="dropdown-item" [class.selected]="selectedFilter === 'REVOKED'" (click)="setFilter('REVOKED'); adminSearch.value = ''">Revoked</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="navIteam">
        <button type="submit" class="btn primary-btn f-l" style="min-width: 89px !important" *ngIf="superadminflag"
          (click)="openModal(adminTemplate)">
          Add Admin<span class="ghg">
            <!-- <ng-icon name="tablerUserPlus" class="font-15"></ng-icon>  -->
          </span>
        </button>
      </div>
    </div>
  </div>

  <div style="display: flex; flex-direction: row;flex-wrap: wrap;" infiniteScroll [alwaysCallback]="true"
   [infiniteScrollDistance]="2" [infiniteScrollThrottle]="300" (scrolled)="onScrollCommunity()">

    <div class="col-sm-12 col-md-6 col-lg-4 pd-0-10p" *ngFor="let data of communityAdminList | async">

      <!-- Same card shell + footer classes as the Members-page user card
           (user-card.component.html) so border, footer background and count
           colours come from the shared theme. -->
      <div class="hpanel contact-panel" style="margin-bottom: 0px !important;">
      <div class="panel-body bg-white-980 cp jsoh border-radius-top-left-right-6 border-radius-bottom-left-right-0">
        <div class="row mr-0-10p admin-card-top">
          <div class="col-sm-4">
            <div>
              <img alt="logo" (click)="userprofile(data.userId)" *ngIf="
                (data.photo != undefined && data.photo != null)" class="img-circle" src="{{ data.photos }}" />

              <img alt="logo" (click)="userprofile(data.userId)" class="img-circle" *ngIf="
                data.photo == undefined ||
                data.photo == null ||
                data.photo == ''
              " src="assets/images/userAvatar.png" />
            </div>
            <div *ngIf="!data.photos">
              <div class="circles" [style.background-color]="getColortwo(data?.firstName, data?.lastName)">
                <div class="circle-text" [style.color]="getTextColor(data?.firstName, data?.lastName)">{{
                  getInitialstwo(data?.firstName, data?.lastName) }}</div>
              </div>
            </div>
          </div>
          <div class="col-sm-8 skdh0">
            <div class="kskls">

              <div class="admin-card-btn">
                <div *ngIf="data.userId == loginUserId && !superadminflag">
                  <span class="label label-info font-normal" style="font-size: 11px">You</span>
                </div>

                <div class="btn-group efef" *ngIf="data.userId == loginUserId">
                  <div *ngIf="superadminflag && data.type == 'SUPERADMIN'">
                    <button type="button" class="btn primary-btn b-5 btn-xs commom-font-12"
                      (click)="superAdmin(transferTemplate, data);$event.stopPropagation();">
                      Transfer Rights
                    </button>
                  </div>
                </div>
                
                <div>
                  <button type="button" class="btn btn-primary b-5 btn-xs" *ngIf="data.userId!=loginUserId"
                    (click)="sendmsg(data);$event.stopPropagation();">Send Message
                    <ng-icon name="tablerMail" class="jwsk" aria-hidden="true"></ng-icon></button>
                </div>
              </div> 

              <!-- Three-dot menu sits inline right after the action button (same row),
                   matching the Members-page card (user-card.component.html). -->
              <div class="btn-group admin-card-more-btn" *ngIf="data.userId != loginUserId" dropdown>
                <a id="button-animated" dropdownToggle  data-toggle="dropdown"
                  *ngIf="data.userId!=userId&&values.isSuperAdmin" class="m-r-10">
                  <img src="assets/icon/icon-vert-thr-dot.png" alt="" srcset="" class="Vthree-dote">
                </a>

                <ng-container *ngIf="selectedFilter  !== 'REVOKED'; else revokedDropdown">

                  <ul class="dropdown-menu r-0-l-auto fnt-12" *dropdownMenu role="menu">
                      <li role="menuitem" *ngIf="superadminflag && data.type == 'ADMIN'">
                        <a class="dropdown-item commom-font-12" (click)="
                                makeSuperAdminTransfer(directtransferTemplate, data);$event.stopPropagation();
                              ">Make Super Admin</a>
                      </li>

                      <li role="menuitem">
                        <a class="dropdown-item commom-font-12" *ngIf="superadminflag && data.type == 'ADMIN'" (click)="
                                revoke(
                                  revokeTemplate,
                                  data.userId,
                                  data.communityId
                                );$event.stopPropagation();
                              ">Revoke</a>
                      </li>
                  </ul>

                </ng-container>

                <ng-template #revokedDropdown>
                    <ul class="dropdown-menu r-0-l-auto fnt-12" *dropdownMenu role="menu">
                        <li role="menuitem">
                          <a class="dropdown-item commom-font-12" *ngIf="selectedFilter === 'REVOKED'"
                          (click)="accept(data.userId); $event.stopPropagation();">
                          Accept
                          </a>
                        </li>
                    </ul>
                </ng-template>
              </div>
            </div>



          </div>
          <div class="col-sm-12" (click)="userprofile(data.userId)">
            <div class="row">
              <div class="col-sm-9">
                <h6 data-toggle="tooltip" data-placement="top" title="{{data.userName}} ">
                  <a class="admin-name"> {{ data.userName }} </a>
                </h6>
              </div>


              <div class="col-sm-3">
                <div class="fl-rtt" *ngIf="data.type=='SUPERADMIN'">
                  <span><img class="crown" title="Owner" src="assets/icon/crown_.PNG" alt=""></span>
                </div>
                <div class="fl-rtt" *ngIf="data.type=='ADMIN' && selectedFilter != 'REVOKED'">
                  <span><img class="crown" title="Admin" src="assets/icon/admin_cogs.PNG" alt=""></span>
                </div>
              </div>

              <div class="col-sm-12 admin-card-meta">
                <div *ngIf="data.title !== undefined && data.title !== null && data.title !== ''" data-toggle="tooltip"
                  data-placement="top" title="{{data.title}} " class="ellipse common-font-11">
                  {{ data.title }}</div>
                <div *ngIf="data.organisation !== undefined && data.organisation !== null && data.organisation !== ''"
                  data-toggle="tooltip" data-placement="top" title="{{data.organisation}} "
                  class="ellipse common-font-11">
                  {{ data.organisation }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="panel-footer contact-footer lahfp border-radius-top-left-right-0">

        <div class="userCard-item">

          <div class="col-sm-4 p-0">
            <div class="contact-stat"><span>Connections </span>
              <strong *ngIf="data.connectionCnt === null || data.connectionCnt === undefined">0</strong>
              <strong
                *ngIf="data.connectionCnt !== null && data.connectionCnt !== undefined">{{data.connectionCnt}}</strong>

            </div>
          </div>

          <div class="col-sm-4 p-0">
            <div class="contact-stat"><span> Jobs </span>
              <strong>{{ data.jobsCount != null && data.jobsCount != undefined ? data.jobsCount : '0' }}</strong>
            </div>
          </div>

          <div class="col-sm-4 p-0">
            <div class="contact-stat"><span> Candidates </span>
              <strong>{{ data.candidatesCount != null && data.candidatesCount != undefined ? data.candidatesCount : '0'
                }}</strong>
            </div>
          </div>

        </div>
      </div>
      </div>

    </div>

    <ng-container *ngIf="commuityLoadScroll">
      <div class="col-sm-12 col-md-6 col-lg-4 padding-right-5 padding-left-0 pd-5"
        *ngFor="let n of ((communityAdminList | async)?.length > 0 ? [1, 2, 3] : [1, 2, 3 , 4 , 5 , 6])">
        <app-common-skeleton [NameOftheScreen]="'usercard'"></app-common-skeleton>
      </div>
    </ng-container>

    <div class="col-sm-12" *ngIf="(communityAdminList | async)?.length === 0 && !commuityLoadScroll">
      <app-nodata-found [title]="['you have no admin']"></app-nodata-found>
    </div>

    <div class="col-sm-12 pl-1 end" *ngIf="communityStopScroll && (communityAdminList | async)?.length > 0"
      style="text-align: center;padding-top: 1rem;">
      <div class="col-sm-12">
        <ng-icon name="tablerCircleCheck" class="end-of-list-icon"></ng-icon>
      </div>
      <div class="col-sm-12">
        <p class="fontchange">You've reached the bottom of the page</p>
      </div>
    </div>


  </div>

  <ng-template #adminTemplate>
    <div class="modal-content">

      <div class="common-header-flex">
        <div>Add Admin</div>
        <button>
          <span (click)="close()" class="common-close">&times;</span>
        </button>
      </div>

      <!-- Same structure as the Business "Add Admin" dialog
           (business-admin.component.html): .modal-body.SuperAdminModelDesign >
           .container, then a .modal-footer. Header/footer styling comes from the
           global `.gs-add-admin-modal` block (styles.scss), set in openModal(). -->
      <div class="modal-body SuperAdminModelDesign">
        <div class="container">
          <div class="col-sm-12">
            <p>Only members of this Community who are connected to you can be added as Admins</p>
          </div>
          <!-- No bindValue: the model is the whole row, so the chip always has a
               label even when the current search page no longer contains it.
               Search is server-side via [typeahead] (community/findCommunityAdminSuggestions). -->
          <div class="col-sm-12">
            <ng-select class="gs-clear-plain" [items]="pageAdminList | async" [multiple]="false"
              [closeOnSelect]="true" [hideSelected]="false" bindLabel="userName"
              [(ngModel)]="admin_data_pop_up" [ngModelOptions]="{standalone: true}"
              [typeahead]="adminTypeahead" (scrollToEnd)="onScrollDown()"
              placeholder="Search in member name" notFoundText="No member found"
              appendTo=".gs-add-admin-modal">

              <ng-template ng-option-tmp let-item="item">
                <div class="item">
                  <img *ngIf="item.photo" alt="logo" class="img-circle" [src]="item.photo">
                  <div *ngIf="!item.photo" class="circles img-circle"
                    [style.background-color]="getColortwo(item?.firstName, item?.lastName)">
                    <div class="admin-circle-text" [style.color]="getTextColor(item?.firstName, item?.lastName)">
                      {{ getInitialstwo(item?.firstName, item?.lastName) }}
                    </div>
                  </div>
                  <a [innerHTML]="item.userName" [title]="item.userName"></a>
                </div>
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-default" (click)="decline()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="addAdmin()">Add Admin</button>
      </div>
    </div>
  </ng-template>

  <ng-template #directtransferTemplate>
    <div class="modal-content">

      <div class="common-header-flex">
        <div>Transfer Super Admin Rights</div>
        <button>
          <span class="common-close" (click)="close()">&times;</span>
        </button>
      </div>


      <div class="modal-body">
        <div class="container-fluid">
          <div class="row">
            <p>
              You will no longer be the Super Admin of this Community Page and
              will not be able to manage other Admins.
            </p>
          </div>
          <div style="float: right">
            <button class="btn secondary-btn" (click)="decline()">
              Cancel
            </button>
            <button class="btn primary-btn" style="margin-left: 5px" (click)="makeSuperAdminTransferAccept()">
              Make Super Admin
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #transferTemplate>
    <div class="modal-content">

      <div class="common-header-flex">
        <div>Transfer Super Admin Rights</div>
        <button>
          <span class="common-close" (click)="close()">&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <div class="container-fluid">
          <div class="row">
            <p>
              You will no longer be the Super Admin of this Community Page and
              will not be able to manage other Admins.
            </p>
            <br />
            <p>
              Super Admin rights can be transfered only to other members connected
            </p>
          </div>
          <div [formGroup]="serachForm">
            <div class="form-group">
              <div class="ng-autocomplete width-500" style="
                color: black !important;
                background-color: black !important;
              ">
                <ng-autocomplete [data]="autoCompleteAdminList" [searchKeyword]="keyword"
                  (selected)="selectEventtransfer($event)" 
                  formControlName="serachData" (inputCleared)="cleardata($event)" (input)="cleardata($event)"
                  [itemTemplate]="itemTemplate" placeHolder="Search In Name" [notFoundTemplate]="notFoundTemplate">
                </ng-autocomplete>
                <ng-template #itemTemplate let-item>
                  <div class="item">
                    <img class="name-diff" src="{{item.photo}}">
                    <a routerLinkActive="router-link-active" [innerHTML]="item.userName"></a> &nbsp;
                  </div>
                </ng-template>
                <ng-template #notFoundTemplate let-notFound>
                  <div [innerHTML]="notFound"></div>
                </ng-template>
              </div>
            </div>
            <div style="float: right">
              <button class="btn btn-default" (click)="decline()">
                Cancel
              </button>
              <button class="btn primary-btn" style="margin-left: 5px" (click)="makeadmin()">
                Make Super Admin
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #revokeTemplate>
    <div class="modal-content">
      <!-- Same header + buttons as the Business Revoke dialog
           (business-admin.component.html #revokeTemplate). -->
      <div class="common-header-flex">
        <div>Revoke</div>
        <button>
          <span class="common-close" (click)="modalRef.hide()" aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="container-fluid">
          <div class="row">
            <p>
              Once you revoke Admin rights, user will no longer be able to manage
              this page
            </p>
          </div>
          <div class="row revoke-actions">
            <button class="btn btn-default" (click)="decline()">Cancel</button>
            <button class="btn primary-btn" (click)="remove()">Revoke</button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
